"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageDataErrorQuerySchema = exports.AnchoredDatumSchema = exports.ComparedValueSchema = exports.DataAnchorAddressSchema = exports.ExperimentAssessmentStatusSchema = exports.ExperimentAssessmentStatus = exports.PackageDataErrorStatementKindSchema = exports.PackageDataErrorStatementKind = exports.DiscrepancyDirectionSchema = exports.DiscrepancyDirection = exports.RowExistenceSchema = exports.RowExistence = exports.ClauseCitationsSchema = exports.ClauseCitationSchema = exports.GroundTruthStandingStatusSchema = exports.GroundTruthStandingStatus = void 0;
exports.datumAgrees = datumAgrees;
const z = require("zod");
const consensus_types_1 = require("../Consensus/consensus.types");
const slice_key_1 = require("../Consensus/slice-key");
const json_value_1 = require("../Utils/json-value");
var GroundTruthStandingStatus;
(function (GroundTruthStandingStatus) {
    GroundTruthStandingStatus["VettedAndCurrent"] = "vetted_and_current";
    GroundTruthStandingStatus["VettedButResolutionChanged"] = "vetted_but_resolution_changed";
    GroundTruthStandingStatus["RowRuledAbsent"] = "row_ruled_absent";
    GroundTruthStandingStatus["NeverAdjudicated"] = "never_adjudicated";
})(GroundTruthStandingStatus || (exports.GroundTruthStandingStatus = GroundTruthStandingStatus = {}));
exports.GroundTruthStandingStatusSchema = z.nativeEnum(GroundTruthStandingStatus);
exports.ClauseCitationSchema = z.object({
    clauseId: z.string(),
    rank: z.number().int().min(1),
});
exports.ClauseCitationsSchema = exports.ClauseCitationSchema.array().superRefine((citations, ctx) => {
    const seenRanks = new Set();
    const seenClauses = new Set();
    for (const [index, citation] of citations.entries()) {
        if (seenRanks.has(citation.rank)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `Duplicate clause rank: ${citation.rank}`,
                path: [index, 'rank'],
            });
        }
        else {
            seenRanks.add(citation.rank);
        }
        if (seenClauses.has(citation.clauseId)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `Duplicate clause citation: ${citation.clauseId}`,
                path: [index, 'clauseId'],
            });
        }
        else {
            seenClauses.add(citation.clauseId);
        }
    }
});
var RowExistence;
(function (RowExistence) {
    RowExistence["Present"] = "present";
    RowExistence["Absent"] = "absent";
})(RowExistence || (exports.RowExistence = RowExistence = {}));
exports.RowExistenceSchema = z.nativeEnum(RowExistence);
var DiscrepancyDirection;
(function (DiscrepancyDirection) {
    DiscrepancyDirection["Missing"] = "missing";
    DiscrepancyDirection["Extra"] = "extra";
})(DiscrepancyDirection || (exports.DiscrepancyDirection = DiscrepancyDirection = {}));
exports.DiscrepancyDirectionSchema = z.nativeEnum(DiscrepancyDirection);
var PackageDataErrorStatementKind;
(function (PackageDataErrorStatementKind) {
    PackageDataErrorStatementKind["Error"] = "error";
    PackageDataErrorStatementKind["ErrorRetracted"] = "error_retracted";
})(PackageDataErrorStatementKind || (exports.PackageDataErrorStatementKind = PackageDataErrorStatementKind = {}));
exports.PackageDataErrorStatementKindSchema = z.nativeEnum(PackageDataErrorStatementKind);
var ExperimentAssessmentStatus;
(function (ExperimentAssessmentStatus) {
    ExperimentAssessmentStatus["NotAssessed"] = "not_assessed";
    ExperimentAssessmentStatus["Pending"] = "pending";
    ExperimentAssessmentStatus["Complete"] = "complete";
})(ExperimentAssessmentStatus || (exports.ExperimentAssessmentStatus = ExperimentAssessmentStatus = {}));
exports.ExperimentAssessmentStatusSchema = z.nativeEnum(ExperimentAssessmentStatus);
exports.DataAnchorAddressSchema = z.object({
    packageId: z.string(),
    sliceKey: slice_key_1.SliceKeySchema,
    sliceVersion: z.number().int(),
    anchor: consensus_types_1.AnchorSchema,
});
exports.ComparedValueSchema = z.object({
    raw: json_value_1.JsonValueSchema,
    normalized: z.string().nullable(),
});
exports.AnchoredDatumSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal(consensus_types_1.AnchorKind.Field), value: exports.ComparedValueSchema }),
    z.object({ kind: z.literal(consensus_types_1.AnchorKind.Row), existence: exports.RowExistenceSchema, rowContentRaw: json_value_1.JsonValueSchema }),
]);
function datumAgrees(left, right) {
    if (right === null || left.kind !== right.kind) {
        return false;
    }
    if (left.kind === consensus_types_1.AnchorKind.Row) {
        return right.kind === consensus_types_1.AnchorKind.Row && left.existence === right.existence;
    }
    return right.kind === consensus_types_1.AnchorKind.Field && left.value.normalized === right.value.normalized;
}
const PackageDataErrorQueryShape = z.object({
    address: exports.DataAnchorAddressSchema,
    datum: exports.AnchoredDatumSchema,
});
exports.PackageDataErrorQuerySchema = PackageDataErrorQueryShape.superRefine((query, ctx) => {
    if (query.datum.kind === query.address.anchor.kind) {
        return;
    }
    ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: query.address.anchor.kind === consensus_types_1.AnchorKind.Field ?
            'A field anchor asks about a value and cannot carry a row datum.'
            : 'A row anchor asks about the row itself and cannot carry a field datum.',
        path: ['datum'],
    });
});
//# sourceMappingURL=package-data-adjudication.types.js.map